import featureImage1 from '../images/illustration-features-tab-1.svg'
import featureImage2 from '../images/illustration-features-tab-2.svg'
import featureImage3 from '../images/illustration-features-tab-3.svg'
export const featuresTabs = {
    "headers" : ["Simple Bookmarking", "Speedy Searching", "Easy Sharing"],
    "content" : [
        {
            "title":   "Bookmark in one click",
            "text": "  Organize your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favorite sites.",
            "btnText": "More Info",
            "btnLink": "#",
            "image":featureImage1
        },
        {
            "title":   "Intelligent search",
            "text": "Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks.",
            "btnText": "More Info",
            "btnLink": "#",
            "image":featureImage2
        },
        {
            "title":   "Share your bookmarks",
            "text": "  Easily share your bookmarks and collections with others. Create a shareable link that you can send at the click of a button.",
            "btnText": "More Info",
            "btnLink": "#",
            "image":featureImage3
        },

    ]
}
export const accordions = [
    {
        id: 1,
        title: 'What is Bookmark?',
        info:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tincidunt justo eget ultricies fringilla. Phasellus blandit ipsum quis quam ornare mattis.',
    },
    {
        id: 2,
        title: 'How can I request a new browser?',
        info:
        '  Vivamus luctus eros aliquet convallis ultricies. Mauris augue massa, ultricies non ligula. Suspendisse imperdiet. Vivamus luctus eros aliquet convallis ultricies. Mauris augue massa, ultricies non ligula. Suspendisse imperdie tVivamus luctus eros aliquet convallis ultricies. Mauris augue massa, ultricies non ligula. Suspendisse imperdiet.',
    },
    {
        id: 3,
        title: 'Is there a mobile app?',
        info:
        'Sed consectetur quam id neque fermentum accumsan. Praesent luctus vestibulum dolor, ut condimentum urna vulputate eget. Cras in ligula quis est pharetra mattis sit amet pharetra purus. Sed sollicitudin ex et ultricies bibendum.',
    },
    {
        id: 4,
        title: 'What about other Chromium browsers?',
        info:
        '  Integer condimentum ipsum id imperdiet finibus. Vivamus in placerat mi, at euismod dui. Aliquam vitae neque eget nisl gravida pellentesque non ut velit.',
    }
    ]